export const properties = {
  icons: window.Liferay.ThemeDisplay.getPathThemeImages() + "/lexicon/icons.svg",
  authToken: window.Liferay.authToken,
  cdnURL: window.Liferay.ThemeDisplay.getCDNBaseURL(),
  languageId: window.Liferay.ThemeDisplay.getLanguageId(),
  portalURL: window.Liferay.ThemeDisplay.getPortalURL(),
};
